export default "__VITE_ASSET__DLrCoREX__"